import { Component, OnInit, Renderer2, inject, input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LayoutService } from '../../services/layout.service';
import { ThemeService } from '../../services/theme.service';

import { RouterModule } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
	selector: 'app-header-side',
	templateUrl: './header-side.template.html',
	standalone: true,
	imports: [
    RouterModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatSelectModule,
    FormsModule,
    MatGridListModule,
    TranslateModule,
    MatOptionModule,
    MatTooltipModule
]
})
export class HeaderSideComponent implements OnInit {
	private themeService = inject(ThemeService);
	private layout = inject(LayoutService);
	translate = inject(TranslateService);
	private renderer = inject(Renderer2);

	// @Input() notificPanel;
	readonly tarifarioPanel = input<MatSidenav>();
	currentLang = 'en';
	public availableLangs = [
		{
			name: 'English',
			code: 'en'
		},
		{
			name: 'Spanish',
			code: 'es'
		}
	];
	public egretThemes;
	public layoutConf: any;
	ngOnInit() {
		this.egretThemes = this.themeService.egretThemes;
		this.layoutConf = this.layout.layoutConf;
		this.translate.use(this.currentLang);
	}
	setLang(e) {
		this.translate.use(this.currentLang);
	}
	changeTheme(theme) {
		this.themeService.changeTheme(this.renderer, theme);
	}
	// toggleNotific() {
	// 	this.notificPanel.toggle();
	// }
	toggleTarifario() {
		this.tarifarioPanel()?.toggle();
	}
	toggleSidenav() {
		if (this.layoutConf.sidebarStyle === 'closed') {
			return this.layout.publishLayoutChange({
				sidebarStyle: 'full'
			});
		}
		this.layout.publishLayoutChange({
			sidebarStyle: 'closed'
		});
	}

	toggleCollapse() {
		// compact --> full
		if (this.layoutConf.sidebarStyle === 'compact') {
			return this.layout.publishLayoutChange(
				{
					sidebarStyle: 'full'
				},
				{ transitionClass: true }
			);
		}

		// * --> compact
		this.layout.publishLayoutChange(
			{
				sidebarStyle: 'compact'
			},
			{ transitionClass: true }
		);
	}
}
